import React from 'react'
import './Dropdown.css'
import PropTypes from "prop-types";

class Dropdown extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      listOpen: false,
    };
    this.close = this.close.bind(this)
  }

  componentDidUpdate(){
    const { listOpen } = this.state;
    setTimeout(() => {
      if(listOpen){
        window.addEventListener('click', this.close)
      }
      else{
        window.removeEventListener('click', this.close)
      }
    }, 0)
  }

  componentWillUnmount(){
    window.removeEventListener('click', this.close)
  }

  close(){
    this.setState({
      listOpen: false
    })
  }

  toggleList(){
    this.setState(prevState => ({
      listOpen: !prevState.listOpen
    }))
  }

  render(){
    const{options, value, defaultText} = this.props;
    const{listOpen} = this.state;
    let selectedOption = null;
    options.forEach((option) => {
      if (option.value === value) {
        selectedOption = {...option};
      }
    });
    return(
      <div className="dd-wrapper">
        <div className="dd-header" onClick={() => this.toggleList()}>
          <div className="dd-header-title">
            {selectedOption && selectedOption.color && <span className="valido" style={{backgroundColor: '#' + selectedOption.color}}/>}
            {selectedOption ? selectedOption.title : defaultText}
            <span className="caret"/>
          </div>
        </div>
        {listOpen && <ul className="dd-list" onClick={e => e.stopPropagation()}>
          {options.map((item)=> (
            <li className="dd-list-item" key={item.value} onClick={() => {
              this.props.onChange(item);
              this.close();
            }}>
              {item.color && <span className="valido" style={{backgroundColor: '#' + item.color}}/>}
              {item.title}
            </li>
          ))}
        </ul>}
      </div>
    )
  }
}

Dropdown.propTypes = {
  value: PropTypes.number.isRequired,
  options: PropTypes.array.isRequired, // {value: integer, title: string, color: string}
  onChange: PropTypes.func.isRequired,
  defaultText: PropTypes.string,
};

Dropdown.defaultProps = {
  defaultText: '',
};

export default Dropdown



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown/Dropdown.js